<script lang="ts">
    import { createEventDispatcher } from "svelte";
    export let adminLogin: boolean;
    export let retry: boolean;
    export let awaitLogin: boolean;

    let password: string;
    let username: string;

    const dispatcher = createEventDispatcher()

    const toggleAdminLogin = () => {
        adminLogin = !adminLogin

        dispatcher("toggleAdminLogin",{
            adminLogin: adminLogin
        })
    }

    const login = () => {
        dispatcher("login", {username: username, password: password})
    }

</script>
<div class="grid justify-items-stretch mx-2">
    <div class="border-2 rounded-xl admin-panel shadow-xl p-2 justify-self-end transition duration-500 ease-in-out transform -translate-y-2 hover:translate-y-1 cursor-pointer select-none" on:click={toggleAdminLogin}>
        {#if !adminLogin}
            Admin-Panel
        {:else}
            Kalender
        {/if}
    </div>
</div>
{#if adminLogin && !awaitLogin}
<div class="border-2 shadow-xl p-3 mt-1">
    <table class="flex justify-center">
        <tbody class="flex-row space-x-2">
            <tr class="flex space-x-2 divide-y-2">
                <td>
                    {#if retry}
                        <div class="mb-2 text-red-400">
                            Benutzername oder Password ist falsch
                        </div>
                    {/if}
                    <div class="grid grid-col-1 mb-3">
                        <label for="user">
                            Benutzername
                        </label>
                        <input bind:value={username} class="border-2 border-gray-200 rounded" name="user">
                    </div>
                    <div class="grid grid-col-1">
                        <label for="pwd">
                            Passwort
                        </label>
                        <input type="password" bind:value={password} class="border-2 border-gray-200 rounded" name="pwd" placeholder="">
                        <input type="submit" value="Login" class="mt-4 p-1 cursor-pointer" on:click={login}> 
                    </div>
                </td>
            </tr>
        </tbody>
    </table>
</div>
{/if}
<style>
    .admin-panel{
        border-top-left-radius: 0;
        border-top-right-radius: 0;
    }
</style>